import { ReactNode } from "react";

import { Content } from "./components";
import { AccountCreationContextProvider } from "./hooks";

export const AccountCreation = ({
    getContinueUrl,
    identityCobranding,
    templateId,
    ...props
}: {
    getContinueUrl?: () => string | undefined;
    identityCobranding?: string;
    templateId?: string;
    Error?: ReactNode;
    Input?: ReactNode;
    Login?: ReactNode;
    Separator?: ReactNode;
    Social?: ReactNode;
    Submit?: ReactNode;
}) => (
    <AccountCreationContextProvider
        getContinueUrl={getContinueUrl}
        identityCobranding={identityCobranding}
        templateId={templateId}
    >
        <Content {...props} />
    </AccountCreationContextProvider>
);
